import dayjs from "dayjs"
import { convertTimestampToDay } from "./convertTimestampToDay"
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const convertToLocalStartTime = (timestamp, userTimezone) => {
  const date = new Date(timestamp)
  const options = { hour12: true, hour: 'numeric', minute: 'numeric', timeZone: userTimezone }
  return date.toLocaleString('en-US', options)
}
export function toCamelCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}
const convertToLocalEndTime = (timestamp, userTimezone) => {
  const date = new Date(timestamp)
  const options = { hour12: true, hour: 'numeric', minute: 'numeric', timeZone: userTimezone }
  return date.toLocaleString('en-US', options)
}
const convertToLocalEndTimeWithTZ = (timestamp, userTimezone) => {
  const date = new Date(timestamp)
  const options = { hour12: true, hour: 'numeric', minute: 'numeric', timeZone: userTimezone }
  return date.toLocaleString('en-US', options)
}
export const updateTimesKeysWithStartTime = (times, userTimezone) => {
  const newTimes = {};

  Object.entries(times).forEach(([dayTimestamp, { start, end }]) => {
    if (!start || !end || isNaN(Number(start)) || isNaN(Number(end))) return;
    const dayDate = dayjs(Number(dayTimestamp)).tz(userTimezone).startOf("day");
    const startDate = dayjs(Number(start)).tz(userTimezone);

    // Combine the day with the time from the start timestamp
    const updatedDate = dayDate
      .hour(startDate.hour())
      .minute(startDate.minute())
      .second(startDate.second())
      .millisecond(startDate.millisecond());

    const updatedTimestamp = updatedDate.utc().valueOf();

    newTimes[updatedTimestamp] = { start: Number(start), end: Number(end), };
  });

  return newTimes;
};
export function classScheduleFormat(times) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  if (times) {
    const dayGroups = {}
    Object.entries(times).forEach(([timestamp, { start, end }]) => {
      const formattedStart = convertToLocalStartTime(start, timezone)
      const formattedEnd = convertToLocalEndTime(end, timezone)
      const hasMinutes = formattedStart.includes(':') || formattedEnd.includes(':')
      const formattedTime = hasMinutes
        ? `${formattedStart} - ${formattedEnd}`
        : `${formattedStart.split(':')[0]} - ${formattedEnd.split(':')[0]}`
      const dayName = convertTimestampToDay(timestamp)
      if (!dayGroups[dayName]) {
        dayGroups[dayName] = []
      }
      dayGroups[dayName].push(formattedTime)
    })

    // Sort the days (keys) of dayGroups
    const sortedDays = Object.keys(dayGroups).sort(
      (a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b)
    );

    const formattedSchedule = sortedDays.map((day) => {
      const capitalizedDay = day.charAt(0).toUpperCase() + day.slice(1)
      const scheduleForDay = dayGroups[day].join(' , ')
      return `${capitalizedDay}: ${scheduleForDay}`
    })

    return formattedSchedule
  }
  return ['No schedule available']
}
export function classScheduleFormatWithoutTimezone(times) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (times && Object.keys(times).length > 0) {
    const dayGroups = {}
    Object.entries(times).forEach(([timestamp, { start, end }]) => {
      const dayName = convertTimestampToDay(timestamp)
      const formattedStart = convertToLocalStartTime(start, timezone)
      const formattedEnd = convertToLocalEndTimeWithTZ(end, timezone)
      const timeRange = `${formattedStart} - ${formattedEnd}`
      if (!dayGroups[dayName]) {
        dayGroups[dayName] = []
      }
      dayGroups[dayName].push(timeRange)
    })

    const sortedDays = Object.keys(dayGroups).sort((dayA, dayB) => {
      const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      return dayOrder.indexOf(dayA) - dayOrder.indexOf(dayB)
    })

    const formattedSchedule = sortedDays.map(dayName => {
      const capitalizedDay = dayName.charAt(0).toUpperCase() + dayName.slice(1)
      const scheduleForDay = dayGroups[dayName].join(', ')
      return `${capitalizedDay}: ${scheduleForDay}`
    })

    return formattedSchedule
  }
  return ['No schedule available']
}